import { render, staticRenderFns } from "./CheckboxWithLabel.vue?vue&type=template&id=fad0b4b8&scoped=true&"
import script from "./CheckboxWithLabel.vue?vue&type=script&lang=js&"
export * from "./CheckboxWithLabel.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxWithLabel.vue?vue&type=style&index=0&id=fad0b4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad0b4b8",
  null
  
)

export default component.exports